import preferencesManager from './updatePropertySelection';
import React from 'react';

const holder = {
  closePropertySelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.outlet({ selectedPropertyIds: holder.selectedPropertyIds, selectedGroupIds: holder.selectedGroupIds });

      window.adminPreferences.selected_group_ids = holder.selectedGroupIds;
      window.adminPreferences.selected_property_ids = holder.selectedPropertyIds;
      preferencesManager.saveAdminPreference({ ...window.adminPreferences, selected_group_ids: holder.selectedGroupIds, selected_property_ids: holder.selectedPropertyIds });

      holder.internalStateSetter('isOpen', false);
      document.removeEventListener("mousedown", holder.closePropertySelector)
    }
  }
};

export default {
  'MultiPropertySelector.Wrapper.Header': async ({ isOpen, containerRef, isReadonly, inputRef, selectedPropertyIds, selectedGroupIds }, outlet, internalStateSetter) => {
    if (isReadonly) return;
    if (isOpen) return;
    await internalStateSetter('isOpen', true);

    let newContainerRef = containerRef;
    let newInputRef = inputRef;

    if (!containerRef || !inputRef) {
      newContainerRef = React.createRef(null);
      newInputRef = React.createRef(null);
      await internalStateSetter({ containerRef: newContainerRef, inputRef: newInputRef });
    }

    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = newContainerRef;
    holder.outlet = outlet;
    holder.selectedPropertyIds = selectedPropertyIds;
    holder.selectedGroupIds = selectedGroupIds;

    newInputRef?.current?.children?.[0]?.children?.[0]?.focus?.()

    document.addEventListener("mousedown", holder.closePropertySelector);
  },
  'MultiPropertySelector.Wrapper.Header.SearchWrapper.SearchInput': ({ value }, _, internalStateSetter) => {
    internalStateSetter({ searchTerm: value })
  },
  'MultiPropertySelector.Wrapper.DropdownWrapper.BorderWrapper.ButtonsWrapper.ListWrapper.ButtonsWrapper.PropertyButton': ({ selectedPropertyId, selectedPropertyIds }, _, internalStateSetter) => {
    const newSelectedPropertyIds = [...selectedPropertyIds];
    const index = newSelectedPropertyIds.indexOf(selectedPropertyId);
    newSelectedPropertyIds.splice(index, 1)

    internalStateSetter({ selectedPropertyIds: newSelectedPropertyIds });
    holder.selectedPropertyIds = newSelectedPropertyIds;
  },
  'MultiPropertySelector.Wrapper.Header.Button': ({ }, outlet, internalStateSetter) => {
    outlet({ selectedPropertyIds: [] });
    internalStateSetter({ isOpen: false });
  },
  'MultiPropertySelector.Wrapper.DropdownWrapper.BorderWrapper.ButtonsWrapper.ListWrapper.ButtonsWrapper.GroupButton': ({ selectedGroupIds, selectedGroupId }, _, internalStateSetter) => {
    const newSelectedGroupIds = [...selectedGroupIds];
    const index = newSelectedGroupIds.indexOf(selectedGroupId);
    newSelectedGroupIds.splice(index, 1)

    internalStateSetter({ selectedGroupIds: newSelectedGroupIds });
    holder.selectedGroupIds = newSelectedGroupIds;
  },
  'MultiPropertySelector.Wrapper.DropdownWrapper.BorderWrapper.ListWrapper.ListWrapper.Property': ({ id, selectedPropertyIds, singleSelect }, outlet, internalStateSetter) => {
    if (singleSelect) {
      outlet({ selectedPropertyIds: [id] });
      preferencesManager.saveAdminPreference({ ...window.adminPreferences, selected_property_ids: [id] });
      internalStateSetter({ isOpen: false });
      document.removeEventListener("mousedown", holder.closePropertySelector);
      return;
    }
    const newSelectedPropertyIds = [...selectedPropertyIds];
    if (newSelectedPropertyIds.includes(id)) {
      const index = newSelectedPropertyIds.indexOf(id);
      newSelectedPropertyIds.splice(index, 1)
    } else {
      newSelectedPropertyIds.push(id);
    }

    internalStateSetter({ selectedPropertyIds: newSelectedPropertyIds });
    holder.selectedPropertyIds = newSelectedPropertyIds;
  },
  'MultiPropertySelector.Wrapper.DropdownWrapper.BorderWrapper.ListWrapper.ListWrapper.Group': ({ selectedGroupIds, id }, _, internalStateSetter) => {
    const newSelectedGroupIds = [...selectedGroupIds];
    if (newSelectedGroupIds.includes(id)) {
      const index = newSelectedGroupIds.indexOf(id);
      newSelectedGroupIds.splice(index, 1)
    } else {
      newSelectedGroupIds.push(id);
    }

    internalStateSetter({ selectedGroupIds: newSelectedGroupIds });
    holder.selectedGroupIds = newSelectedGroupIds;
  },
  'MultiPropertySelector.Wrapper.DropdownWrapper.BorderWrapper.ClearAllHeader.ClearAll': ({ selectedGroupIds, selectedPropertyIds, properties }, _, internalStateSetter) => {
    if (selectedGroupIds.length > 0 || selectedPropertyIds.length > 0) {
      internalStateSetter({ selectedGroupIds: [], selectedPropertyIds: [] });
      holder.selectedGroupIds = [];
      holder.selectedPropertyIds = [];
    } else {
      internalStateSetter({ selectedGroupIds: [], selectedPropertyIds: properties.map(p => p.id) });
      holder.selectedGroupIds = [];
      holder.selectedPropertyIds = properties.map(p => p.id);
    }
  }
}